import { IPaymentDeliveryWorkerQuery } from "../../models/payment-delivery-worker/query";
import {
  IPaymentDeliveryWorker,
  IPaymentDeliveryWorkerDetails,
} from "../../models/payment-delivery-worker/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import toggleLoading from "../../utils/helpers/xor";
import paramsReducer from "../base/base-reducer";
import { QueryAction } from "../base/base-reducer";
import { IInternalState, PaymentDeliveryWorkerLoading } from "./context";

type Action =
  | {
      type: "LOADING";
      payload: {
        loading: PaymentDeliveryWorkerLoading | PaymentDeliveryWorkerLoading[];
      };
    }
  | {
      type: "SET_LIST";
      payload: { list: IBaseListingResponse<IPaymentDeliveryWorker> };
    }
  | {
      type: "SET_DETAILSS";
      payload: { details?: IPaymentDeliveryWorkerDetails };
    }
  | QueryAction<IPaymentDeliveryWorkerQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }

    case "SET_DETAILSS": {
      return {
        ...state,
        details: action.payload.details,
      };
    }

    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
